import { BaseFetch } from "../main-model";
export default class StockModel extends BaseFetch {
  
    getStockBy = (data) =>
    this.authFetch({
      url: "stock/getStockBy",
      method: "POST",
      body: data,
    });

    getStockById = (data) =>
    this.authFetch({
      url: "stock/getStockById",
      method: "POST",
      body: data,
    });

    insertStock = (data) =>
      this.authFetch({
        url: "stock/insertStock",
        method: "POST",
        body: data,
      });

      insertExcelStock = (data) =>
      this.authFetch({
        url: "stock/insertExcelStock",
        method: "POST",
        body: data,
      });

    updateStockById = (data) =>
    this.authFetch({
      url: "stock/updateStockById",
      method: "POST",
      body: data,
    });

    deleteStockById = (data) =>
    this.authFetch({
      url: "stock/deleteStockById",
      method: "POST",
      body: data,
    });
}